import React, { useState } from "react";
import { Upload, Form, Input, InputNumber, Button, Spin, message } from "antd";
import { UploadOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const AdminCreatePlan = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("admin"));

  const onFinish = async (values) => {
    setLoading(true);
    const formData = new FormData();

    if (fileList[0]?.originFileObj) {
      formData.append("plan_logo", fileList[0].originFileObj);
    }

    Object.keys(values).forEach((key) => {
      formData.append(key, values[key]);
    });

    try {
      const res = await fetch(`${process.env.REACT_APP_APIURL}/admin/createplan`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
        body: formData,
      });

      const response = await res.json();

      if (response?.status_code === 200) {
        toast.success("Plan added Successfully");
        navigate("/admin/plan/all-plans");
      } else {
        toast.error(response.message || response.err);
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-lg md:text-2xl font-semibold">{t("Add_New_Plan")}</h2>
        <Link to="/admin/plan/all-plans">
          <button className="btn btn-sm btn-primary text-white">
            <span className="mr-2" ><ArrowLeftOutlined /></span> {t("Go_Back")}
          </button>
        </Link>
      </div>

      {loading ? (
        <Spin size="large" className="block mx-auto mt-20" />
      ) : (
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          className="bg-white p-6 rounded shadow-md"
        >
          <Form.Item
            name="plan_name"
            label={t("Plan_required")}
            rules={[{ required: true, message: t("Plan_required") }]}
          >
            <Input placeholder={t("Plan_Name")} />
          </Form.Item>

          <Form.Item
            label={t("Plan_Logo")}
            name="plan_logo"
            valuePropName="fileList"
            getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
          >
            <Upload
              listType="picture"
              fileList={fileList}
              beforeUpload={() => false}
              onChange={({ fileList }) => setFileList(fileList)}
              maxCount={1}
            >
              <Button icon={<UploadOutlined />}>{t("add_new_product_T_img_info")}</Button>
            </Upload>
          </Form.Item>

          <Form.Item
            name="plan_description"
            label={t("Plan_Description")}
            rules={[{ required: true, message: t("Description_required") }]}
          >
            <Input placeholder={t("Plan_Description")} />
          </Form.Item>

          <Form.Item
            name="plan_price"
            label={t("Plan_Price")}
            rules={[{ required: true, message: t("Price_required") }]}
          >
            <InputNumber min={0} className="w-full" placeholder={t("all_product_dataTable2")} />
          </Form.Item>

          <Form.Item
            name="product_limit"
            label={t("Product_Limit")}
            rules={[{ required: true, message: t("Product_Limit_required") }]}
          >
            <InputNumber min={0} className="w-full" placeholder={t("Product_Limit")} />
          </Form.Item>

          <Form.Item
            name="storage_limit"
            label={t("Storage_Limit")}
            rules={[{ required: true, message: t("Limit_required") }]}
          >
            <InputNumber min={0} className="w-full" placeholder={t("Storage_Limit")} />
          </Form.Item>

          <Form.Item
            name="customer_limit"
            label={t("Customer_Limit")}
            rules={[{ required: true, message: t("C_Limit_required") }]}
          >
            <InputNumber min={0} className="w-full" placeholder={t("Customer_Limit")} />
          </Form.Item>

          <Form.Item
            name="no_of_days"
            label={t("Number_of_Days")}
            rules={[{ required: true, message: t("Days_required") }]}
          >
            <InputNumber min={1} className="w-full" placeholder={t("add_new_product_price_place")} />
          </Form.Item>

          <Form.Item>
            <button type="submit" className="btn btn-primary text-white mt-2" disabled={loading}>
              {t("Save")}
            </button>
          </Form.Item>
        </Form>
      )}
    </>
  );
};

export default AdminCreatePlan;
